import React, { useState, useEffect } from 'react'
import './AdvAllStepCss/AdvBasicInfoStep.css'
import homeImg from "../../../Assets/website png.png"
import {
  convertToMMDDYYYY,
  formatDate,
  parseDateChange,
  showFieldError,
  formatDobDisplay,
  allFieldsTouched,
  setAllFieldsTouched,
} from "../../../utils/helper.js";
import { useFormik } from "formik";
import VerificationProfile from "../../HomeCollectionPageElements/VerificationProfile.jsx";
import { getOtp, getProfileStatus, validateOtp } from "../../../api/api.js";
import { getReferralDoctor, getTestList } from "../../../api/api.js";
import CustomLoader from "../../../common/loader/CustomLoader.jsx";
import { useNavigate } from "react-router-dom";
import OtpValidate from "../../../PageElements/HomeCollectionPageElements/OtpValidate.jsx";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { getUserData, getUserMobile } from "../../../utils/auth.js";
import useValidateForm from "../../../Hooks/useValidateForm.jsx";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { defaultFormData } from "../../../utils/defaultFormData.js";
import { FaUser, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import { MdDateRange, MdLocationCity } from "react-icons/md";
import { IoMaleFemale } from "react-icons/io5";
import { HiLocationMarker } from "react-icons/hi";
// for referral doctor 
 
 import ReferralDoctorModal from "../../HomeCollectionPageElements/ReferralDoctorModal.jsx";


const AdvBasicInfoStep = ({
  onNext,
  onBack,
  formData,
  setFormData,
  setFormValid,
  patientType,
  setPatientType,
  setIsOtpverified,
  isOtpVerified,
  selectedPatient,
  setSelectedPatient,
  setShowOtp,
  showOtp,
  setShowVerification,
  showVerification,
  showPatientType,
  setShowPatientType,
  profileData,
  setProfileData,
  // destructuring choose doctor 
  chooseDoctor = [],
  handleChange,
  allFieldsTouched,
  setAllFieldsTouched,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const isLoggedin = Boolean(getUserData());
  const mobileData = getUserMobile();
  const [visibleErrors, setVisibleErrors] = useState({});
  const [validationErrorList, setValidationErrorList] = useState("");
  const [touchedFields, setTouchedFields] = useState({});
  // for referal doctor state
  const [showReferralModal, setShowReferralModal] = useState(false);
  const [referralDoctorSearch, setReferralDoctorSearch] = useState("");
  const [referralDoctorList, setReferralDoctorList] = useState([]);
  const [doctorData, setDoctorData] = useState(null);
  // for choose test doc state
   const [isOpenChooseDoctor, setIsOpenChooseDoctor] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
    // for choose test doc functionality

    const handleOpenTest = ()=>{
            setIsOpenChooseDoctor(!isOpenChooseDoctor)
    }

    const handleSelectDoctor = (doctor)=>{
        setSelectedDoctor(doctor);
        setIsOpenChooseDoctor(false);
    }


  // complete choose test doc functionality 




  const profileSchema = Yup.object({
    mobile_no: Yup.string()
      .required("Mobile number is required")
      .matches(
        /^[0-9]{10}$/,
        "Please enter 10 digits to continue with the Home Collection Request"
      ),
    PFirstName: Yup.string()
      .required("First name is required")
      .matches(/^[a-zA-Z\s]+$/, "Special characters not allowed"),
    PLastName: Yup.string()
      .required("Last name is required")
      .matches(/^[a-zA-Z\s]+$/, "Special characters not allowed"),
    dateofbirth: Yup.string().required("Date of birth is required"),
    PSex: Yup.string().required("Gender is required"),
    email: Yup.string().email("Invalid email format").nullable().notRequired(),
    // Address fields validation
    address: Yup.string().required("Address is required"),
    City: Yup.string().required("City is required"),
    State: Yup.string().required("State is required"),
    Zipcode: Yup.string()
      .matches(/^[0-9]{6}$/, "Pincode must be exactly 6 digits")
      .required("Pincode is required"),
    landmark: Yup.string().nullable(),
  });
  // for referral doc schema 

  const bookingSchema = Yup.object({
  ref_doctor: Yup.string()
    .required("Referral doctor is required"),
});

const combinedSchema = profileSchema.concat(bookingSchema);


  const { isValid, fieldErrors } = useValidateForm(formData, combinedSchema);


  useEffect(() => {
    setFormValid(isValid);
  }, [isValid]);

  useEffect(() => {
    if (
      !isOtpVerified &&
      formData.mobile_no.length === 10 &&
      profileData.length === 0
    ) {
      handleCheckProfile();
    }
  }, []);

  useEffect(() => {
    if (!isOtpVerified && (formData.mobile_no || "").toString().length === 10) {
      console.log("Mobile number is valid:", formData.mobile_no);
      handleCheckProfile();
    }
  }, [formData.mobile_no, isOtpVerified]);

  const handleCheckProfile = async () => {
    const payload = {
      RBAuthKey: "RBDWAh!Q1s74e",
      user_id: "",
      mobile_no: formData?.mobile_no.toString(),
    };
    try {
      setLoading(true);
      const res = await getProfileStatus(payload);
      console.log("Profile Status Response:", res);
      setProfileData(res?.data?.data);
    } catch (error) {
      console.error("Error checking profile:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = () => {
    navigate("/login");
  };

  const handleOtp = async () => {
    try {
      setLoading(true);
      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        mobile_no: formData?.mobile_no.toString(),
      };
      const res = await getOtp(payload);
      console.log("OTP Response:", res);
      toast.success("OTP sent successfully.");
      setShowVerification(false);
      setShowOtp(true);
    } catch (error) {
      console.error("Error generating OTP:", error);
      toast.error("Failed to generate OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitVerify = async (otp) => {
    console.log("Verifying OTP:", otp);

    try {
      if (otp.length < 4) {
        toast.error("Please enter a valid 4-digit OTP.");
        return;
      }

      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        user_id: formData?.mobile_no.toString(),
        OTP: otp,
        Reg_status: "1",
      };

      const res = await validateOtp(payload);
      console.log("OTP Verification Response:", res);
      if (res?.data?.status === "success") {
        toast.success("OTP verified successfully.");
        setIsOtpverified(true);
        setShowOtp(false);
        setShowVerification(false);
        setShowPatientType(true);
      } else {
        toast.error("OTP verification failed. Please try again.");
      }
    } catch (error) {
      toast.error("OTP verification failed. Please try again.");
    }
  };

  const handlePatientChange = (e) => {
    const userId = e.target.value;
    setSelectedPatient(userId);

    const selectedProfile = profileData.find(
      (profile) => profile.user_id.toString() === userId
    );

    if (selectedProfile) {
      setFormData((prev) => ({
        ...prev,
        user_id: selectedProfile.user_id || "",
        mobile_no: selectedProfile.mobile_no || "",
        PFirstName: selectedProfile.PFirstName || "",
        PLastName: selectedProfile.PLastName || "",
        email: selectedProfile.email || "",
        dateofbirth: parseDateChange(selectedProfile.dateofbirth),
        PSex:
          selectedProfile.PSex === "M"
            ? "M"
            : selectedProfile.PSex === "F"
              ? "F"
              : "M",
        address: selectedProfile.address || "",
        landmark: selectedProfile.landmark || "",
        Zipcode: selectedProfile.Zipcode || "",
        City: selectedProfile.City || "",
        State: selectedProfile.State || "",
        altPhone: selectedProfile.altPhone || "",
      }));
    }
  };

  const capitalizeFirstLetter = (text = "") =>
    text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();

  function handleSpecialChar(e) {
    const value = e.target.value;
    if (/^[a-zA-Z\s]*$/.test(value)) {
      handleChange(e);
    }
  }

  function handleOnlyNumber(e) {
    const value = e.target.value;
    if (/^[0-9]*$/.test(value)) {
      handleChange(e);
    }
  }

  // referral doctor model 

   const handleOpenReferral = () => setShowReferralModal(true);

   const handleReferralSelect = (doctor) => {
    setTouchedFields((prev) => ({ ...prev, ref_doctor: true }));

    setFormData((prev) => ({
      ...prev,
      ref_doctor: doctor.name,
      ref_doctorID: doctor.id,
      specialization: doctor.specialization,
      regNo: doctor.regNo,
    }));
    console.log("doctorData is", doctorData);
    setShowReferralModal(false);
    setReferralDoctorSearch("");
  };
  const handleFindReferralDoctor = async (e) => {
      const value = e.target.value;
      setReferralDoctorSearch(value);
  
      if (value.length < 2) return;
  
      try {
        setLoading(true);
        const res = await getReferralDoctor({ name: value });
        setReferralDoctorList(res?.data?.data || []);
      } catch {
        toast.error("Error fetching doctors");
      } finally {
        setLoading(false);
      }
    };

    console.log("chooseDoctor in basic info section ====>",chooseDoctor);
    
  return (
    <>
      {loading && <CustomLoader />}
      <div className="profile-form-main">
        {/* LEFT: FORM */}
        <div className="profile-form-container">
          <h2 className="form-heading">Patient Basic Information</h2>

          {/* Row 1 - Mobile & Patient Type */}
          <div className="profile-form-row">
            <div className="profile-form-group">
              <input
                type="tel"
                name="mobile_no"
                disabled={isLoggedin || isOtpVerified}
                value={isLoggedin ? mobileData : formData.mobile_no}
                onChange={(e) => {
                  handleOnlyNumber(e);
                  setTouchedFields((prev) => ({
                    ...prev,
                    mobile_no: true,
                  }));
                }}
                onPaste={(e) => e.preventDefault()}
                placeholder="Mobile Number*"
                autoComplete="off"
                maxLength={10}
                onFocus={(e) => {
                  if (!isOtpVerified && formData?.mobile_no?.length === 10) {
                    handleCheckProfile();
                  }
                }}
              />
              {(allFieldsTouched ||
                showFieldError(touchedFields, fieldErrors, "mobile_no")) && (
                  <span className="error-text">{fieldErrors.mobile_no}</span>
                )}
            </div>

            <div className="profile-form-group">
              <label>
                Select Patient Type<span>*</span>
              </label>
              <div className="radio-group">
                <label>
                  <input
                    type="radio"
                    name="patientType"
                    value="existing"
                    checked={patientType === "existing"}
                    onChange={() => setPatientType("existing")}
                    onBlur={(e) =>
                      setTouchedFields((prev) => ({
                        ...prev,
                        [e.target.name]: true,
                      }))
                    }
                  />{" "}
                  Existing
                </label>
                <label>
                  <input
                    type="radio"
                    name="patientType"
                    value="new"
                    checked={patientType === "new"}
                    onChange={() => {
                      setPatientType("new");
                      setSelectedPatient("");
                      setFormData({
                        ...defaultFormData,
                        mobile_no: formData.mobile_no,
                      });
                    }}
                    onBlur={(e) =>
                      setTouchedFields((prev) => ({
                        ...prev,
                        [e.target.name]: true,
                      }))
                    }
                  />{" "}
                  New
                </label>
              </div>
            </div>

            {patientType === "existing" && profileData.length > 0 && (
              <div className="profile-form-group wide-select">
                <select value={selectedPatient} onChange={handlePatientChange}>
                  <option value="">-- Select Patient Name --</option>
                  {profileData.map((profile) => (
                    <option key={profile.user_id} value={profile.user_id}>
                      {`${profile.PFirstName} ${profile.PLastName}`}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>

          {/* Row 2 - Name */}
          <div className="profile-form-row">
            <div className="profile-form-group">
              <input
                type="text"
                name="PFirstName"
                placeholder="First Name*"
                value={formData.PFirstName}
                onChange={(e) => {
                  handleSpecialChar(e);
                  setTouchedFields((prev) => ({
                    ...prev,
                    [e.target.name]: true,
                  }))
                }}
                autoComplete="off"
                onBlur={(e) =>
                  setTouchedFields((prev) => ({
                    ...prev,
                    [e.target.name]: true,
                  }))
                }
                readOnly={patientType === "existing"}
              />
              {(allFieldsTouched ||
                showFieldError(touchedFields, fieldErrors, "PFirstName")) && (
                  <span className="error-text">{fieldErrors.PFirstName}</span>
                )}
            </div>

            <div className="profile-form-group">
              <input
                type="text"
                name="PLastName"
                placeholder="Last Name*"
                value={formData.PLastName}
                onChange={(e) => {
                  handleSpecialChar(e);
                  setTouchedFields((prev) => ({
                    ...prev,
                    [e.target.name]: true,
                  }))
                }}
                autoComplete="off"
                onBlur={(e) =>
                  setTouchedFields((prev) => ({
                    ...prev,
                    [e.target.name]: true,
                  }))
                }
                readOnly={patientType === "existing"}
              />
              {(allFieldsTouched ||
                showFieldError(touchedFields, fieldErrors, "PLastName")) && (
                  <span className="error-text">{fieldErrors.PLastName}</span>
                )}
            </div>
          </div>

          {/* Row 3 - DOB & Gender */}
          <div className="profile-form-row">
            <div className="profile-form-group">
              <DatePicker
                selected={formData.dateofbirth}
                onChange={(date) =>
                  setFormData((prev) => ({ ...prev, dateofbirth: date }))
                }
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                dateFormat="dd/MM/yyyy"
                maxDate={new Date()}
                placeholderText="Date of Birth*"
                className="custom-date-input"
                readOnly={patientType === "existing"}
              />
              {(allFieldsTouched ||
                showFieldError(touchedFields, fieldErrors, "dateofbirth")) && (
                  <span className="error-text">{fieldErrors.dateofbirth}</span>
                )}
            </div>
            <div className="profile-form-group">
              <label>
                Gender<span>*</span>
              </label>
              <div className="radio-group">
                <label>
                  <input
                    type="radio"
                    name="PSex"
                    value="M"
                    checked={formData.PSex === "M"}
                    onChange={handleChange}
                    onBlur={(e) =>
                      setTouchedFields((prev) => ({
                        ...prev,
                        [e.target.name]: true,
                      }))
                    }
                  />{" "}
                  Male
                </label>
                <label>
                  <input
                    type="radio"
                    name="PSex"
                    value="F"
                    checked={formData.PSex === "F"}
                    onChange={handleChange}
                    onBlur={(e) =>
                      setTouchedFields((prev) => ({
                        ...prev,
                        [e.target.name]: true,
                      }))
                    }
                  />{" "}
                  Female
                </label>
              </div>
              {(allFieldsTouched ||
                showFieldError(touchedFields, fieldErrors, "PSex")) && (
                  <span className="error-text">{fieldErrors.PSex}</span>
                )}
            </div>
          </div>

          {/* Row 4 - Email & Alt Phone */}
          <div className="profile-form-row">
            <div className="profile-form-group">
              <input
                type="email"
                name="email"
                placeholder="Email(optional)"
                value={formData.email}
                onChange={(e) => {
                  handleChange(e);
                  setTouchedFields((prev) => ({
                    ...prev,
                    [e.target.name]: true,
                  }))
                }}
                autoComplete="off"
                onBlur={(e) =>
                  setTouchedFields((prev) => ({
                    ...prev,
                    [e.target.name]: true,
                  }))
                }
              />
              {(allFieldsTouched ||
                showFieldError(touchedFields, fieldErrors, "email")) && (
                  <span className="error-text">{fieldErrors.email}</span>
                )}
            </div>

            <div className="profile-form-group">
              <input
                type="text"
                name="altPhone"
                maxLength={10}
                placeholder="Alternative Number (optional)"
                value={formData.altPhone}
                onChange={handleOnlyNumber}
                autoComplete="off"
                inputMode="numeric"
                pattern="[0-9]*"
              />
            </div>
          </div>

          {/* ADDRESS SECTION HEADING */}
          <h2 className="form-heading" style={{ marginTop: '2rem' }}>Address Information</h2>

          {/* Row 5 - Address & Landmark */}
          <div className="profile-form-row">
            <div className="profile-form-group">
              <input
                type="text"
                name="address"
                placeholder="Enter Address*"
                value={formData.address}
                onChange={handleChange}
                autoComplete="off"
                onBlur={(e) =>
                  setTouchedFields((prev) => ({
                    ...prev,
                    [e.target.name]: true,
                  }))
                }
              />
              {(allFieldsTouched ||
                showFieldError(touchedFields, fieldErrors, "address")) && (
                  <span className="error-text">{fieldErrors.address}</span>
                )}
            </div>
            <div className="profile-form-group">
              <input
                type="text"
                name="landmark"
                placeholder="Landmark (optional)"
                value={formData.landmark}
                onChange={handleSpecialChar}
                autoComplete="off"
              />
            </div>
          </div>

          {/* Row 6 - State, City, Pincode */}
          <div className="profile-form-row">
            <div className="profile-form-group">
              <input
                type="text"
                name="State"
                value={formData?.State || ''}
                autoComplete="off"
                placeholder="Enter State*"
                onChange={handleChange}
                onBlur={(e) =>
                  setTouchedFields((prev) => ({
                    ...prev,
                    [e.target.name]: true,
                  }))
                }
              />
              {(allFieldsTouched ||
                showFieldError(touchedFields, fieldErrors, "State")) && (
                  <span className="error-text">{fieldErrors.State}</span>
                )}
            </div>

            <div className="profile-form-group">
              <select
                name="City"
                value={formData.City}
                onChange={handleChange}
                onBlur={(e) =>
                  setTouchedFields((prev) => ({
                    ...prev,
                    [e.target.name]: true,
                  }))
                }
              >
                <option value="">Select City*</option>
                <option value="Kolkata">Kolkata</option>
                <option value="Howrah">Howrah</option>
              </select>
              {(allFieldsTouched ||
                showFieldError(touchedFields, fieldErrors, "City")) && (
                  <span className="error-text">{fieldErrors.City}</span>
                )}
            </div>

            <div className="profile-form-group">
              <input
                type="text"
                name="Zipcode"
                placeholder="Pincode*"
                maxLength="6"
                value={formData.Zipcode}
                onChange={handleOnlyNumber}
                autoComplete="off"
                onBlur={(e) =>
                  setTouchedFields((prev) => ({
                    ...prev,
                    [e.target.name]: true,
                  }))
                }
              />
              {(allFieldsTouched ||
                showFieldError(touchedFields, fieldErrors, "Zipcode")) && (
                  <span className="error-text">{fieldErrors.Zipcode}</span>
                )}
            </div>
          </div>
        </div>

        {/* RIGHT: COMPLETE INFO PREVIEW */}
        <div className="basic-info-box">
          <div className="basic-info-header">
            <h3 style={{ color: "#00796b" }}>Information Preview</h3>
          </div>

          <div className="basic-info-details">
            {/* BASIC INFO SECTION */}
            <div style={{ marginBottom: '1.5rem' }}>
              <h4 style={{ color: "#00796b", fontSize: '0.9rem', marginBottom: '0.5rem', borderBottom: '1px solid #e0e0e0', paddingBottom: '0.3rem' }}>Basic Details</h4>

              {/* Name */}
              {(formData.PFirstName || formData.PLastName) && (
                <div className="info-box-address">
                  <FaUser className="info-icon" />
                  <span className="info-value-address">
                    {capitalizeFirstLetter(formData.PFirstName)}{" "}
                    {capitalizeFirstLetter(formData.PLastName)}
                  </span>
                </div>
              )}

              {/* Gender */}
              {formData?.PSex && (
                <div className="info-box-address">
                  <IoMaleFemale className="info-icon" />
                  <span className="info-value-address">
                    {formData.PSex === "M" ? "Male" : "Female"}
                  </span>
                </div>
              )}

              {/* Mobile */}
              {formData?.mobile_no && (
                <div className="info-box-address">
                  <FaPhoneAlt className="info-icon" />
                  <span className="info-value-address">{formData.mobile_no}</span>
                </div>
              )}

              {/* Date of Birth */}
              {formData?.dateofbirth && (
                <div className="info-box-address">
                  <MdDateRange className="info-icon" />
                  <span className="info-value-address">
                    {formatDobDisplay(formData?.dateofbirth)}
                  </span>
                </div>
              )}

              {/* Email */}
              {formData?.email && (
                <div className="info-box-address">
                  <FaEnvelope className="info-icon" />
                  <span className="info-value-address">{formData.email}</span>
                </div>
              )}
            </div>

            {/* ADDRESS SECTION */}
            {(formData.address || formData.City || formData.State || formData.Zipcode) && (
              <div>
                <h4 style={{ color: "#00796b", fontSize: '0.9rem', marginBottom: '0.5rem', borderBottom: '1px solid #e0e0e0', paddingBottom: '0.3rem' }}>Address Details</h4>

                {/* Full Address */}
                {formData?.address && (
                  <div className="info-box-address">
                    <FaMapMarkerAlt className="info-icon" />
                    <span className="info-value-address">{formData.address}</span>
                  </div>
                )}

                {/* Landmark */}
                {formData?.landmark && (
                  <div className="info-box-address">
                    <HiLocationMarker className="info-icon" />
                    <span className="info-value-address">Near {formData.landmark}</span>
                  </div>
                )}

                {/* City, State, Pincode */}
                {(formData?.City || formData?.State || formData?.Zipcode) && (
                  <div className="info-box-address">
                    <MdLocationCity className="info-icon" />
                    <span className="info-value-address">
                      {[formData.City, formData.State, formData.Zipcode].filter(Boolean).join(", ")}
                    </span>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {/* appoinment booking info  pages */}

               <div className='select-doctor-section'>

              <div className="booking-form-group full-width">
  {/* Always present wrapper */}
  <div className="margin-top-5 margin-bottom-5 custom-data-box">
    {formData.ref_doctor && !fieldErrors.ref_doctor && (
      <>
        <p
          className="p-nomargin"
          style={{ color: "green", fontSize: "0.8rem" }}
        >
          {`Dr. ${formData?.ref_doctor}`}
        </p>
        <p
          className="p-nomargin"
          style={{ color: "green", fontSize: "0.8rem" }}
        >
          {`Reg No: ${formData?.regNo}`}
        </p>
        <p
          className="p-nomargin"
          style={{ color: "green", fontSize: "0.8rem" }}
        >
          {formData?.specialization}
        </p>
      </>
    )}
  </div>

  <button
    type="button"
    className="action-btn"
    onClick={handleOpenReferral}
  >
    Choose Referral Doctor
  </button>

  {(allFieldsTouched ||
    showFieldError(touchedFields, fieldErrors, "ref_doctor")) && (
    <span style={{ fontSize: "0.8rem", color: "red" }}>
      {fieldErrors.ref_doctor}
    </span>
  )}
</div>

  {/* choose test doc  */}
  <div className="container">
      <div className="wrapper">
        <div className="card">
          {/* <h2 className="title">Select Prefered Doctor</h2> */}

          {selectedDoctor && (
            <div className="selected-info">
              <p className="selected-label">Selected Doctor:</p>
              <p className="selected-name">{selectedDoctor.Doctor}</p>
            </div>
          )}

          <div className="dropdown-container">
            <button
              type="button"
              className="action-btn"
              onClick={handleOpenTest}
            >
              {selectedDoctor ? 'Change Prefered Doctor' : 'Select Prefered Doctor'}

            </button>

            {isOpenChooseDoctor && (
  <select
    className="adv-dropdown"
    onChange={(e) => {
      const selectedDoctor = chooseDoctor.find(
        (doc) => doc.ServTimingID === Number(e.target.value)
      );
      handleSelectDoctor(selectedDoctor);
    }}
    defaultValue=""
  >
    <option value="" disabled>
      Select Doctor
    </option>

    {chooseDoctor.map((doctor) => (
      <option key={doctor.ServTimingID} value={doctor.ServTimingID}>
        {doctor.Doctor}
      </option>
    ))}
  </select>
)}

          </div>

          {isOpenChooseDoctor && (
            <div
              className="overlay"
              onClick={() => setIsOpenChooseDoctor(false)}
            />
          )}

        </div>
      </div>
    </div>
<br />
        



      </div>
        {showReferralModal && (
              <ReferralDoctorModal
                onClose={() => setShowReferralModal(false)}
                onChange={handleFindReferralDoctor}
                referralDoctorList={referralDoctorList}
                referralDoctor={referralDoctorSearch}
                onSelect={handleReferralSelect}
              />
            )}

      <div className="step-footer">
        <button
          className="btn-secondary"
          onClick={onBack}
        >
          Back
        </button>

        <button
          className="btn-primary"
          disabled={!isValid}
          onClick={onNext}
        >
          Continue to Confirmation
        </button>
      </div>

    </>
  );
};

export default AdvBasicInfoStep;